import { AcceptTermsLabel } from "@circle-react/components/OnboardingPage/CreateProfilePage/AcceptTermsLabel";
import { Checkbox } from "@circleco/compass/components/Checkbox";
import { Controller, useFormContext } from "react-hook-form";

const termsOfServiceKey = "termsOfService" as const;

export const CheckoutFormTOS = () => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={termsOfServiceKey}
      render={({ field: { onChange, value } }) => (
        <Checkbox
          id="terms"
          checked={!!value}
          onCheckedChange={onChange}
          data-testid="checkout-form-terms-checkbox"
          label={<AcceptTermsLabel variant="paywallCheckout" />}
        />
      )}
    />
  );
};
